import { useEffect  } from "react";
import { BrowserRouter as Router, Routes, Route} from "react-router-dom";
import Menu from "./Menu";

import Przydasie from "./useful/Przydasie";
import Transport from "./useful/transport/Transport";
import Accident from "./useful/accident/Accident";
import Embassy from "./useful/embassy/Embassy";
import Links from "./useful/links/Links";
import Weather from "./useful/weather/Weather"

import Poland from "./poland/Poland";
import PolandMap from "./poland/polandmap/PolandMap";
import Quizz from "./poland/quizz/Quizz";
import PhotoGame from "./poland/photogame/PhotoGame";
import Dance from "./poland/dance/Dance";
import Twisters from "./poland/twisters/Twisters";
import Designs from "./poland/designs/Designs";

import SMD from "./sdm/SDM";
import Hymn from "./sdm/hymn/Hymn";
import Meetings from "./sdm/meetings/Meetings";
import Description from "./sdm/meetings/Description";
import Schema from "./sdm/meetings/Schema";
import Essence from "./sdm/meetings/Essence";
import Topic from "./sdm/meetings/Topic";
import Reading from "./sdm/reading/Reading";
import Saints from "./sdm/saints/Saints";
import Shedule from "./sdm/shedule/Shedule";

import ZHR from "./zhr/ZHR";
import Rules from "./zhr/rules/Rules";
import BS from "./zhr/bs/BS";
import Drive from "./zhr/drive/Drive";
import Insurance from "./zhr/insurance/Insurance";
import Users from "./zhr/users/Users";

import Navigation from "./components/Navigation";
import Mapa from "./map/Mapa";
import Places from "./places/Places";
import Info from './Info';
import User from './user/User';
import PrivacyPolicy from "./privacy_policy/PrivacyPolicy";

import { dynamicPositionStore } from "./map/dynamicPositionStore";
import useLocalStorageState from "use-local-storage-state";
import { AuthProvider } from "./globalContext";
import { userStateStore } from "./zhr/users/usersStateStore";

import "./Default.css"
import SignIn from "./components/SignIn";
import HistoryMap from "./map/HistoryMap";


const EMPTY_TOKEN: string = "";
const EMPTY_USER_ID: string = "";
const DEFAULT_IS_ADMIN: boolean = false
const DEFAULT_DARK_MODE: boolean = false



function App() {
  const [token, setToken] = useLocalStorageState("token", { storageSync: false, defaultValue: EMPTY_TOKEN })
  const [userID, setUserID] = useLocalStorageState("user_id", { storageSync: false, defaultValue: EMPTY_USER_ID })
  const [isAdmin, setIsAdmin] = useLocalStorageState("is_admin", { storageSync: false, defaultValue: DEFAULT_IS_ADMIN })

  useEffect(() => {
    const queryParams = new URLSearchParams(document.location.search)
    const tokenParam = queryParams.get("token")
    const user = queryParams.get("id")
    const admin = queryParams.get("admin")

    
    if(tokenParam !== null && user !== null){
      setToken(tokenParam)
      setUserID(user)
      setIsAdmin(admin === "true")
      if(tokenParam!==""){ //login
        document.cookie=`token=${tokenParam}; SameSite=Strict;` // link login case
        dynamicPositionStore.reconnectWs(user);
        userStateStore.populate(true);
      }
      else{ //logout
        document.cookie=`token=${""}; SameSite=Strict; expires=Thu, 01 Jan 1970 00:00:00 GMT`
        userStateStore.destroyPopulation()
      }
      window.history.replaceState(null,'','/') //cosmetic
      
    }
    else if(token!==""){
      document.cookie=`token=${token}; SameSite=Strict;` // link login case
      dynamicPositionStore.reconnectWs(userID);
      userStateStore.populate(false);
    }

  }, [token])


  // dark mode
  const [theme, setTheme] = useLocalStorageState("theme",{storageSync: false, defaultValue: DEFAULT_DARK_MODE});
  const toggleTheme = () => setTheme(!theme);
  useEffect(() => {
    if (theme) document.body.classList.add("dark");
    else document.body.classList.remove("dark");
  })


  if (token === EMPTY_TOKEN)
  {
    return (
      <div className="App">
        <SignIn />
      </div>
    )
  }

  return (
    <div className="App">
      <AuthProvider.Provider value={{ id: userID, token: token, admin: isAdmin }}>
        <Router>
          <Routes>

            <Route path="/" element={<Menu />} />

            <Route path="/przydasie" element={<Przydasie />} />
            <Route path="/transport" element={<Transport />} />
            <Route path="/accident" element={<Accident />} />
            <Route path="/embassy" element={<Embassy />} />
            <Route path="/links" element={<Links />} />
            <Route path="/weather/*" element={<Weather />} />

            <Route path="/poland" element={<Poland />} />
            <Route path="/polandmap" element={<PolandMap />} />
            <Route path="/quizz" element={<Quizz />} />
            <Route path="/photoGame" element={<PhotoGame />} />
            <Route path="/dance" element={<Dance />} />
            <Route path="/twisters" element={<Twisters />} />
            <Route path="/designs" element={<Designs />} />

            <Route path="/sdm" element={<SMD />} />
            <Route path="/hymn" element={<Hymn />} />
            <Route path="/meetings" element={<Meetings />} />
            <Route path="/description" element={<Description />} />
            <Route path="/schema" element={<Schema />} />
            <Route path="/essence" element={<Essence />} />
            <Route path="/topic" element={<Topic />} />
            <Route path="/reading/*" element={<Reading />} />
            <Route path="/saints/*" element={<Saints />} />
            <Route path="/shedule" element={<Shedule />} />

            <Route path="/zhr" element={<ZHR />} />
            <Route path="/rules" element={<Rules />} />
            <Route path="/bs" element={<BS />} />
            <Route path="/drive" element={<Drive />} />
            <Route path="/insurance" element={<Insurance />} />
            <Route path="/users/*" element={<Users />} />

            <Route path="/map" element={<Mapa />} />
            <Route path="/map-history" element={<HistoryMap />} />
            <Route path="/places/*" element={<Places />} />
            <Route path="/info" element={<Info />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />

            <Route path="/user" element={
              <User>
                <button onClick={toggleTheme} className="submit">
                  <img src={theme ? "/icons/sun-solid.svg" : "/icons/moon-solid.svg"} alt="img" className="img"></img>
                  {theme ? "light" : "dark"}
                </button>
              </User>
            } />

          </Routes>
          <Navigation/>
        </Router>
      </AuthProvider.Provider>  
    </div>
  );
}

export default App;
